import { render, staticRenderFns } from "./PremiumActionButton.vue?vue&type=template&id=1a4a76ef"
import script from "./PremiumActionButton.vue?vue&type=script&lang=js"
export * from "./PremiumActionButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports